import React, { useContext } from "react";
import { graphql } from "gatsby";
import { getUrlWithCosmosCampaignParams } from "../../utilities/businessLogic";
import { Global } from "../../context/globalContextProvider";
import { useCollectAnchorLinks } from "../../context/anchorLinksContextProvider";

//fields
import Button from "../base/button";
import FormGroup from "../contentfulModal/formGroup";

//hooks
import useFormInitFieldWithUrlParams from "../../hooks/useFormInitFieldWithUrlParams";

/**
 * This form is:
 * - Forms that redirect to another form, doesn't make any submission
 * - Forms that set isCampaign to true
 * - Forms that updates the redirect link may based on field value: amount=donationAmount&selection=selectionTab
 */
const CampaignForm = ({
  formGroups,
  arrowIcon = null,
  campaignToDonationLink = null,
  donationTopButton = null,
  donationPageAnchor = null,
  cosmosCampaignId = null,
  blockIndex = null,
}) => {
  const { urlParams, donationAmount, donationFrequency } = useContext(Global);
  const defaultAmount = formGroups[0].defaultAmount ?? 10;
  useCollectAnchorLinks(formGroups[0].heading ?? "Donate form", "donation", blockIndex);
  useFormInitFieldWithUrlParams(defaultAmount);

  return (
    <form id="donation" name="donation" className="donationForm">
      {formGroups.map((group, index) => {
        return <FormGroup formGroup={group} formGroupId={donationPageAnchor} arrowIcon={arrowIcon} key={`form-parent-group-` + index} />;
      })}
      <div className={"submit--container"}>
        <Button
          href={getUrlWithCosmosCampaignParams(
            campaignToDonationLink,
            {
              ...urlParams,
              amount: donationAmount,
              selection: donationFrequency,
            },
            cosmosCampaignId
          )}
          className={"btn-donation"}
          text={donationTopButton}
        />
      </div>
      <hr className="is-campaign-hr"></hr>
    </form>
  );
};

export default CampaignForm;

export const query = graphql`
  fragment CampaignFormGroup on ContentfulFormGroup {
    ...FormGroupComponent
  }
`;
